export const assertUnreachable = (
  x: never,
  msg: string = "Should not have gotten here!"
): never => {
  console.error(x);
  throw new Error(msg);
};
